import { makeStyles } from "@material-ui/styles";

const incompleteButtonGroupStyles = makeStyles((theme) => ({
	gridContainer: {
		display: "flex",
		lineHeight: "normal",
		[theme.breakpoints.up("sm")]: {
			justifyContent: "space-around"
		},
		[theme.breakpoints.down("xs")]: {
			justifyContent: "center"
		}
	},
	formControlLabel: {
		"& .MuiTypography-body1": {
			fontSize: "9px",
			[theme.breakpoints.only("xs")]: {
				opacity: 0.7
			},
			[theme.breakpoints.up("sm")]: {
				opacity: 0
			}
		}
	}
}));

export default incompleteButtonGroupStyles;
